import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { LogService } from '../../../services/shared/log.service';
import { NGaugeService } from '../../../services/shared/ngauge.service';
import { PubSubService } from '../../../services/shared/pub-sub.service';
import { TechService } from '../../../services/tech.service';
import { UserService } from '../../../services/user.service';
import {
  ADD_PAGE, CORPORATE, EDIT_PAGE, LOG_LEVELS, LOG_MESSAGES, PLUS_CLICK,
  TEXT_AREA_TOOL_TIP, VIEW_PAGE
} from '../../../util/constants';
import { AuthService } from '../../../services/shared/auth.service';

@Component({
  selector: 'app-report-issue',
  templateUrl: './report-issue.component.html',
  styleUrls: ['./report-issue.component.scss']
})
export class ReportIssueComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('issueSort') issueSort: MatSort;
  @Input() editValue;
  isLoading = true;
  panelOpenState1: any;
  panelOpenState2: any;
  dataSource: MatTableDataSource<any>;
  displayColumns = ['Title', 'Status', 'Action'];
  reportForm: FormGroup;
  statusValues = ['New', 'Open', 'InProgress', 'Resolved'];
  priorities = ['Critical', 'Blocker', 'Major', 'Low'];
  selectedIndex = 0;
  imageUrl: any;
  tabTitle = '';
  viewMode = ADD_PAGE;
  issue: any;
  saveClicked = false;
  propertyReportId: any;
  statusDescription = '';
  filteredStatus: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  statusFilterCtrl: FormControl = new FormControl();
  textToolTip = TEXT_AREA_TOOL_TIP;

  saveReportSubscription: Subscription;
  getReportedIssueSubscription: Subscription;
  getReportIssueByIdSubscription: Subscription;
  dialogCloseSubscription: Subscription;
  updateGradeSubscription: Subscription;
  is_a_superadmin:boolean=false;
  constructor(
    private ngaugeService: NGaugeService,
    private formBuilder: FormBuilder,
    private pubSubService: PubSubService,
    private logService: LogService,
    private userService: UserService,
    private authservice:AuthService,
    private techService: TechService) {
    this.logUserActivity('Report Issue', LOG_MESSAGES.CLICK);
    this.isLoading = true;
    this.is_superadmin();
  }

  ngOnInit() {
    this.buildStatusDropdown();
    this.reportForm = this.buildForm();
    this.tabTitle = '';
  }

  ngAfterViewInit() {
    if (this.ngaugeService.checkForNllUndef(this.editValue)) {
      this.isLoading = true;
      this.saveClicked = false;
      this.propertyReportId = Number(this.editValue['value']);
      this.getReportIssueByIdSubscription = this.techService.getReportIssueByPropertyId(this.propertyReportId,
        this.editValue['property']).subscribe(response => {
          this.statusValues = ['New', 'Open', 'Assigned', 'InProgress', 'Resolved'];
          this.buildStatusDropdown();
          if (this.editValue['view'] === EDIT_PAGE) {
            this.reportForm.get('statusDescription').setValidators([Validators.required, Validators.maxLength(512)]);
            this.reportForm.get('issuePriority').setValidators(Validators.required);
            this.statusValues = ['New', 'Open', 'Assigned', 'InProgress', 'Resolved'];
            if (response[0]['status'] === 'Assigned') {
              this.viewMode = '';
            }
            this.editIssue(response[0]);
          } else {
            this.viewIssue(response[0]);
          }
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'Report Issues', 'On Fetch Report Issues By Id', JSON.stringify(error));
        });
    }
    this.getReportedIssues();
  }

  reportImageViewer() {
    const image = new Image();
    image.src = this.imageUrl;
    const win = window.open('');
    win.document.write(image.outerHTML);
  }

  getReportedIssues() {
    this.dataSource = new MatTableDataSource([]);
    const params = this.techService.getFilterParams('updatedOn');
    this.getReportedIssueSubscription = this.techService.getReportedIssues(params).subscribe(data => {
      this.setDataSource(data, this.paginator, this.issueSort);
      this.getReportedIssueSubscription.unsubscribe();
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Report Issue', 'On fetch report issues', JSON.stringify(error));
    });
  }

  setDataSource(data: any, paginator: MatPaginator, sort: MatSort) {
    this.dataSource = this.techService.getMatTable(data, paginator, sort);
    this.isLoading = false;
  }

  buildStatusDropdown() {
    this.ngaugeService.buildFilter(this.statusFilterCtrl, this.filteredStatus, this.statusValues, '');
  }

  addReportIssue() {
    this.statusDescription = '';
    this.editValue = null;
    this.saveClicked = false;
    this.viewMode = ADD_PAGE;
    this.tabTitle = this.viewMode + ' Report Issue';
    this.reportForm = this.buildForm();
    this.reportForm.get('status').patchValue('New');
    this.selectedIndex = 1;
    this.imageUrl = '';
    this.logUserActivity('Report Issue', PLUS_CLICK);
    setTimeout(() => {
      this.reportForm.get('statusDescription').setErrors(null);
    }, 200);
  }

  changeTabs(tabName) {
    this.logUserActivity('Report Issue', tabName);
    if (tabName === 'Report') {
      this.selectedIndex = 0;
      this.getReportedIssues();
    }
  }

  fieldChanged(value, formField) {
    this.reportForm.get(formField).setValue(value);
    this.reportForm.markAsDirty();
  }

  buildForm() {
    return this.formBuilder.group({
      about: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      stepsReproduce: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      expectedBehavior: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      observedBehavior: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      status: ['', Validators.required],
      statusDescription: ['', Validators.maxLength(512)],
      issuePriority: ['']
    });
  }

  addIssuePicture(event) {
    this.logUserActivity('Repor Issue - Issue Screenshots', PLUS_CLICK);
    const files = event.target['files'];
    if (files) {
      for (const file of files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          if (file.size <= 1000000 && (file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('png'))) {
            this.imageUrl = e.target.result;
          } else {
            const swalObject = {
              title: '<strong>Invalid Image Found</strong>',
              text: 'Please upload an image (.jpg, .jpeg, .png) with file size lesser than 1 MB',
            };
            const areYouSure = this.ngaugeService.swalOKButton(swalObject);
            Swal(areYouSure);
          }
        };
        reader.readAsDataURL(file);
      }
    }
    this.reportForm.markAsDirty();
  }

  editIssue(issue) {
    this.issue = issue;
    if (this.ngaugeService.checkForNllUndef(issue['propertyreportId'])) {
      this.propertyReportId = Number(issue['propertyreportId']);
    }
    this.saveClicked = false;
    this.viewMode = EDIT_PAGE;
    this.statusDescription=issue.statusDescription;
    this.reportForm.addControl('property', new FormControl(issue.property));
    this.reportForm.addControl('SID', new FormControl(issue.SID));
    this.tabTitle = this.viewMode + ' Report Issue';
    this.formatView(issue);
    this.logUserActivity('Report Issue - Edit', issue.about);
  }

  formatView(issue) {
    let base64 = '';
    const url = issue['observedScreenshot'];
    for (let i = 0; i < url['data'].length; i++) {
      base64 += String.fromCharCode(url['data'][i]);
    }
    base64 = base64.replace(/["']/g, '');
    base64 = `data:image/jpeg;base64,${base64}`;
    this.imageUrl = base64;
    this.reportForm.addControl('id', new FormControl(issue.id));
    this.reportForm.patchValue(issue);
    this.selectedIndex = 1;
    this.isLoading = false;
  }

  viewIssue(issue) {
    this.viewMode = VIEW_PAGE;
    this.tabTitle = this.viewMode + ' Report Issue';
    this.formatView(issue);
    this.logUserActivity('Report Issue - View', issue.about);
  }

  removeImage() {
    this.logUserActivity('Repor Issue - Issue Screenshots', 'Delete Clicked');
    const swalObject = {
      title: '<strong>Are you sure</strong>',
      text: 'Do you want to remove the clicked Screenshot?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    };
    const primaryContactExist = this.ngaugeService.swalOkCancelButton(swalObject);
    Swal(primaryContactExist).then(result => {
      if (result.value) {
        this.imageUrl = '';
        this.logUserActivity('Repor Issue - Issue Screenshots - Delete', 'Yes');
        this.reportForm.markAsDirty();
      } else {
        this.logUserActivity('Repor Issue - Issue Screenshots - Delete', 'No');
      }
    });
  }

  downloadImage() {
    const link = document.createElement('a');
    link.href = this.imageUrl;
    link.download = 'nGauge_Issue_Screenshot.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.logUserActivity('Repor Issue - Issue Screenshots', 'Download');
  }

  getIssue(id, viewType) {
    this.getReportIssueByIdSubscription = this.techService.getReportIssueById(id).subscribe(response => {
      this.statusDescription = response[0]['statusDescription'];
      switch (viewType) {
        case 'edit': this.editIssue(response[0]); break;
        case 'view': this.viewIssue(response[0]); break;
        case 'grade': this.updateGrade(response[0]); break;
      }
    });
  }

  closereportIssue() {
    this.techService.publishCloseSideNavTriggerer('close');
    this.logUserActivity('Report Issues', LOG_MESSAGES.CANCEL);
  }

  async save(value) {
    this.saveClicked = true;
    this.logUserActivity('Report Issue - Save', LOG_MESSAGES.CLICK);
    if (this.reportForm.dirty) {
      value['observedScreenshot'] = this.imageUrl.replace(/^data:image\/[a-z]+;base64,/, '');
      if (this.viewMode === ADD_PAGE) {
        value['id'] = 0;
        value['createdBy'] = this.userService.getLoggedInUserId();
        value['property'] = this.userService.getLoggedInUserProperty();
        value['createdName'] = this.userService.getLoggedInUserName();
      }
      setTimeout(() => {
        this.saveIssue(value);
      }, 200);
    } else {
      this.selectedIndex = 0;
      this.tabTitle = '';
    }
  }

  saveIssue(issue) {
    if (this.viewMode === EDIT_PAGE) {
      issue['createdBy'] = this.issue['createdBy'];
      issue['updated'] = this.userService.getLoggedInUserId();
      issue['updatedBy'] = this.userService.getLoggedInUserId();
    }
    if (this.ngaugeService.checkForNllUndef(this.propertyReportId)) {
      issue['propertyreportId'] = this.propertyReportId;
    }
    if (issue.status === 'New') {
      issue['status'] = 'Open';
    }
    issue['updatedOn'] = new Date();
    const propertyType = this.userService.getLoggedInPropertyType();
    issue['iscorporate'] = propertyType === CORPORATE ? true : false;
    this.saveReportSubscription = this.techService.saveReportIssue(issue).subscribe(data => {
      if (data['result']) {
        setTimeout(() => {
          this.tabTitle = '';
          this.selectedIndex = 0;
          const currentUrl = this.ngaugeService.getCurrentUrl();
          if (currentUrl.includes('helpCenter')) {
            this.pubSubService.publish('help-center-modified');
          }
          this.ngaugeService.toastrSuccess('Issue reported successfully');
          this.logUserActivity('Report Issue - Save', LOG_MESSAGES.SUCCESS);
        }, 1000);
      } else {
        this.saveClicked = false;
        this.ngaugeService.toastrError('Issue report failed');
        this.logUserActivity('Report Issue - Save', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Report Issue', 'On Add Issue', JSON.stringify(issue));
      }
    }, error => {
      this.saveClicked = false;
      this.logService.logError(LOG_LEVELS.DEBUG, 'Report Issue', 'On Add Issue', JSON.stringify(error));
    });
  }

  updateGrade(issue) {
    this.logUserActivity('Report Issues - Grade', LOG_MESSAGES.CLICK);
    if(issue.SourceID != this.authservice.getSID()){
      this.ngaugeService.toastrError('You cannot grade this Report');
        this.logUserActivity('Report Issue- Grade', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Report Issue', 'On Add/Edit of Report ISSUE', JSON.stringify(issue));
        return
    }
    const dialogRef = this.techService.openGradeComponent(issue);
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async result => {
      issue = this.techService.getMoreAttributes(issue, result);
      delete issue['observedScreenshot'];
      this.updateGradeSubscription = this.techService.saveReportIssue(issue).subscribe(() => {
        this.logUserActivity('Report Issues - Grade - Ok', LOG_MESSAGES.CLICK);
        this.ngaugeService.toastrSuccess('Issue Updated Successfully');
        setTimeout(() => {
          this.techService.publishCloseSideNavTriggerer('close');
        }, 100);
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Report Issue', 'On update grade', JSON.stringify(error));
      });
    });
  }

  pasteClipboardContent(fieldName, placeHolder) {
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Report Issue - ' + action, 'Paste ' + placeHolder);
    let preValue = this.reportForm.get(fieldName).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this.reportForm.get(fieldName).patchValue(preValue + text);
    });
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.saveReportSubscription);
    this.unSubscribe(this.getReportedIssueSubscription);
    this.unSubscribe(this.getReportIssueByIdSubscription);
    this.unSubscribe(this.dialogCloseSubscription);
    this.unSubscribe(this.updateGradeSubscription);
    this.paginator = null;
    this.issueSort = null;
    this.panelOpenState1 = null;
    this.panelOpenState2 = null;
    this.dataSource = null;
    this.displayColumns = null;
    this.reportForm = null;
    this.statusValues = null;
    this.selectedIndex = null;
    this.imageUrl = null;
    this.tabTitle = null;
    this.viewMode = null;
    this.issue = null;
    this.saveClicked = null;
    this.propertyReportId = null;
    this.isLoading = null;
    this.ngaugeService = null;
    this.formBuilder = null;
    this.logService = null;
    this.userService = null;
    this.techService = null;
    this.filteredStatus = null;
    this.statusFilterCtrl = null;
    this.textToolTip = null;
  }

  checksaveconditions(){ //if the ask is new no condition to save if not only ansering person(superadmin from ymc can save)
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if((this.viewMode==='Add'|| this.viewMode==='Edit') && (this.statusDescription===''|| (this.issue.status !=="InProgress" || this.issue.status !=="Resolved"))){
      if(this.viewMode==='Add'){
        return true
      }
      else{
        if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
          return true
        }
        else{
          return false
        }
  
      }
    }
    else{
      return false
    }
   
   
  }
  is_superadmin(){
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
      this.is_a_superadmin=true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/tech-support/report-issue/report-issue.component.ts